import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';


import { ServiceBase } from '@app/services/base.service';

import { TipoDeAcao } from '@app/models/tipo-de-acao.model';

@Injectable()
export class TipoDeAcaoService extends ServiceBase {
  constructor(
    private http: HttpClient,
  ) {
    super();
  }
  gravar(tipoDeAcao: TipoDeAcao): Observable<any> {
    return this.http.post<any>(this.URL_API + "configuracoes/tipodeacao", tipoDeAcao);
  }

  deletar(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `configuracoes/tipodeacao/${id}`);
  }


  obterPorId(id: number): Observable<any> {
    return this.http.get<any>(this.URL_API + `configuracoes/tipodeacao/${id}`);
  }

  obterLista(descricao: string, pagina: number): Observable<any> {
    descricao = encodeURIComponent(descricao);
    return this.http.get<any>(this.URL_API + `configuracoes/tipodeacao/lista/?descricao=${descricao}&pagina=${pagina}`, { headers: { meta: ['search'] }});
  }

  // obterTipoDeAcao() {
  //   return this.http.post(this.URL_API + "configuracoes/tipodeacao/pesquisar")
  //     .map((res: Response) => <TipoDeAcao[]>res.json());
  // };

  // obterTodos() {
  //   return this.http.get(this.URL_API + `configuracoes/tipodeacao/`)
  //     .map((res: Response) => res.json());
  // }

  // obterAdvogadoPorTipoDeAcaoId(id: number) {
  //   return this.http.get(this.URL_API + `configuracoes/tipodeacao/ObterPorIdAdvogado/?id=${id}`)
  //     .map((res: Response) => <number>(res.json()));
  // }

}
